import { Expose } from 'class-transformer';
import { FieldType } from './field-type';
import { DeviceType } from '../../vehicles/model/device-type';
import { CellType } from './cell-type';

export class ValueField {
  @Expose({ name: 'field_id' })
  fieldId: number;
  name: string;
  type: FieldType;
  primaryKey: boolean;
  xpath: string;
  format: string;
  conversion: string;
  @Expose({ name: 'device_type' })
  deviceType: DeviceType;
  @Expose({ name: 'col_number' })
  colNumber: number;
  @Expose({ name: 'field_name' })
  fieldName: string;
  @Expose({ name: 'use_in_comparision' })
  useInComparison: boolean;
  @Expose({ name: 'comparision_diff' })
  comparisonDiff: number;
  @Expose({ name: 'not_device' })
  notDevice: boolean;
  property: boolean;
  visible: boolean;
  translatable: boolean;
  jsonpath: string;
  @Expose({ name: 'can_filter' })
  canFilter: boolean;
  @Expose({ name: 'default_hidden' })
  defaultHidden: boolean;
  options?: Option[];
  title: string;
  disableSort: boolean;
  groupingHeaderName?: string;
  cellType?: CellType;
  groupingValueTranslatable: boolean;
  constValue?: string;
  printable: boolean;
  style?: Record<string, string>;
  // TODO do adaptcji z STP3 serverem, rozwiazanie tymczasowe
  canGroup: boolean = true;
  permanentlyHidden: boolean;
  // Kolumna bez słownika options, dla której filtr kolumnowy ma zbudować listę wartości do wyboru
  // z danych wczytanych do tabeli (unikalne wartości kolumny). Filtrowanie po fragmencie tekstu
  // zostaje - działa razem z wyborem z listy.
  filterOptionsFromData?: boolean;
  // Nazwa właściwości wiersza z wartością surową, dla kolumn, których komórka pokazuje wartość
  // ozdobioną (nr boczny pojazdu dokleja "✍️" przy zgłoszeniu ręcznym i "⬅️ ..." przy podmianie).
  // Z niej składa się lista filtra kolumnowego i po niej idzie dopasowanie wyboru z listy - filtrom
  // ozdobniki są obojętne, a bez tego z listy szłoby "5301", gdy w kolumnie stoi "5301✍️".
  // Dopasowanie po fragmencie tekstu zostaje przy kolumnie, żeby dało się szukać po tym, co widać.
  rawValueFieldName?: string;
  // Klucz tłumaczenia pozycji "bez wartości" doklejanej na początek listy filtra kolumnowego
  // (np. "Bez uchybień") - i tej ze słownika pola, i tej budowanej z danych (filterOptionsFromData),
  // gdzie wiersze z pustą kolumną nie mają czym się reprezentować. Dotyczy tylko filtra kolumnowego -
  // słownik pola zostaje nietknięty.
  filterEmptyOptionLabel?: string;

  groupingValueFormat(value?: any): any {
    return value;
  }

  rowValueExtractor?: (row: any) => any;
}

export interface Option {
  key: any;
  value: string;
  disabled?: boolean;
  isHtml?: boolean;
  /** Liczba do plakietki obok podpisu, np. ilu użytkowników należy do grupy. Bez niej plakietki nie ma. */
  badge?: number;
}
